import Filter from 'www/modules/Filters/Filter'

import FilterTypeService from 'www/modules/Filters/service/filter-types/FilterTypeService'
import FilterTypeSort from 'www/modules/Filters/service/filter-types/FilterTypeSort'

export default class FilterGroupService {
  constructor({
    service,
    sort,
  }) {
    this.service = new Filter(new FilterTypeService(service.list), service.initial)
    this.sort = new Filter(new FilterTypeSort(), sort.initial)
  }

  setFilters({
    service,
    sort,
  }) {
    this.service.setSelectedOptionByValue(service)
    this.sort.setSelectedOptionByValue(sort)
  }

  resetFilters() {
    this.sort.reset()
  }

  isAnyApplied() {
    return !this.sort.isDefault()
  }

  getAppliedNum() {
    const filterList = [
      this.sort,
    ]

    return filterList.filter(filter => !filter.isDefault()).length
  }

  getFiltersAppliedNames() {
    const res = []

    if (!this.sort.isDefault()) {
      res.push(FilterTypeSort.getAppliedName(this.sort))
    }

    return res
  }
}
